exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-interior-page-js": () => import("./../../../src/templates/interiorPage.js" /* webpackChunkName: "component---src-templates-interior-page-js" */)
}

